import { Button, Modal } from "@9amhealth/shared";
import type { FC } from "react";
import { IconClose } from "src/constants/icons";
import translate from "src/lib/translate";
import Translate from "src/ui/components/Translate/Translate";
import {
  Actions,
  Card,
  CloseButton,
  Content,
  Description,
  Headline,
  Hero,
  confirmButtonStyle,
  modalStyle
} from "./SkipCoachingSessionModal.styled";

interface SkipCoachingSessionModalProps {
  isOpen: boolean;
  /** The member backing out on purpose — buttons, backdrop and Escape. Fires once per close. */
  onCancel: () => void;
  /** Runs on every close, including after a confirmed skip, so it must stay silent. */
  onDismissed: () => void;
  onConfirm: () => void;
}

export const SkipCoachingSessionModal: FC<SkipCoachingSessionModalProps> = ({
  isOpen,
  onCancel,
  onDismissed,
  onConfirm
}) => (
  <Modal
    isOpen={isOpen}
    variant="alert"
    className={modalStyle}
    onWillDismiss={onCancel}
    onDidDismiss={onDismissed}
    ariaLabel={translate("skipCoachingSession.headline")}
  >
    <Card>
      <Hero>
        <CloseButton
          type="button"
          onClick={onCancel}
          aria-label={translate("close")}
        >
          <IconClose />
        </CloseButton>
      </Hero>

      <Content>
        <div>
          <Headline>
            <Translate msg="skipCoachingSession.headline" />
          </Headline>
          <Description>
            <Translate msg="skipCoachingSession.description" />
          </Description>
        </div>

        <Actions>
          <Button
            theme="danger"
            className={confirmButtonStyle}
            onPress={onConfirm}
          >
            <Translate msg="skipCoachingSession.confirm" />
          </Button>
          <Button theme="simple" hideArrow center onPress={onCancel}>
            <Translate msg="skipCoachingSession.cancel" />
          </Button>
        </Actions>
      </Content>
    </Card>
  </Modal>
);
